import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from '../router';
import Icon from './Icon';

const items = [
  { label: 'Work', to: '/projects' },
  { label: 'Services', to: '/#services' },
  { label: 'About', to: '/#about' },
  { label: 'Journal', to: '/journal' },
];

function HoverLink({ item, onNavigate, active }) {
  const navigate = useNavigate();
  const [holding, setHolding] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!holding) { setProgress(0); return undefined; }
    const started = performance.now();
    const timer = window.setInterval(() => {
      const next = Math.min(100, ((performance.now() - started) / 1500) * 100);
      setProgress(next);
      if (next >= 100) {
        window.clearInterval(timer);
        onNavigate();
        navigate(item.to);
      }
    }, 40);
    return () => window.clearInterval(timer);
  }, [holding, item.to, navigate, onNavigate]);

  return (
    <Link className={`nav-link${active ? ' is-active' : ''}`} to={item.to} aria-label={`Open ${item.label} section`} aria-current={active ? 'page' : undefined} onClick={() => { setHolding(false); onNavigate(); }} onPointerEnter={() => setHolding(true)} onPointerLeave={() => setHolding(false)} style={{ '--hold-progress': `${progress}%`, '--hold-value': progress }}>
      <span className="nav-link-orbit" aria-hidden="true"><svg viewBox="0 0 100 44" preserveAspectRatio="none"><ellipse className="orbit-base" cx="50" cy="22" rx="47" ry="19" pathLength="100"/><ellipse className="orbit-progress" cx="50" cy="22" rx="47" ry="19" pathLength="100"/></svg></span>
      <span className="nav-link-label">{item.label}</span><span className="nav-link-cue" aria-hidden="true"><Icon name="arrowUp" size={11}/></span><span className="hover-meter" aria-hidden="true" />
    </Link>
  );
}

export default function Header({ dark, toggleDark }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="site-header">
      <Link className="wordmark" to="/" aria-label="Kingshuk home"><span>K</span>Kingshuk.</Link>
      <button className="menu-toggle" onClick={() => setOpen((value) => !value)} aria-label="Toggle menu"><Icon name={open ? 'close' : 'menu'} /></button>
      <nav className={open ? 'is-open' : ''} aria-label="Main navigation">
        <div className="nav-links">
          {items.map((item) => {
            const [itemPath, itemHash = ''] = item.to.split('#');
            const active = itemHash ? location.pathname === itemPath && location.hash === `#${itemHash}` : location.pathname === itemPath || (itemPath !== '/' && location.pathname.startsWith(`${itemPath}/`));
            return <HoverLink item={item} active={active} key={item.label} onNavigate={() => setOpen(false)} />;
          })}
        </div>
        <div className="nav-actions">
          <button className="theme-toggle" onClick={toggleDark} aria-label={`Switch to ${dark ? 'light' : 'dark'} mode`}><Icon name={dark ? 'sun' : 'moon'} size={18} /></button>
          <Link className="client-link" to="/client"><span className="status-dot" /> Client portal</Link>
          <Link className="button button--small" to="/#contact">Start a project <Icon name="arrowUp" size={16} /></Link>
        </div>
        <p className="hover-hint">Tap a menu item to open that section.</p>
      </nav>
    </header>
  );
}
